import {
  GENERATE_DOCUMENTATION,
  SET_LOADER
} from "./types";
import { apiService } from "../utils/serviceApi";
import { createDocumentErrorNotification } from "../common/notifications/notification";
import { downloadFile } from "../utils/downloadFile";

export const generateSueDocumentationForDO =
  (ticketId, licencePlate) => async (dispatch) => {
    dispatch({
      type: SET_LOADER,
      payload: true,
    });
    return apiService
      .getDocument(
        `${process.env.REACT_APP_SERVICE_URL}/api/report/${ticketId}/${licencePlate}/generateSueDocsForDO`
      )
      .then(async (response) => {
        // only mark the ticket as documented once the document really arrived
        if (await downloadFile(response, "documentation.zip")) {
          dispatch({
            type: GENERATE_DOCUMENTATION,
            payload: ticketId,
          });
        }
      })
      .catch((e) => {
        createDocumentErrorNotification(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
  };
